var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapBack = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.20581C15 9.49058 14.7884 9.72593 14.5138 9.76318L14.4375 9.76831L3.1875 9.76831C2.87684 9.76831 2.625 9.51647 2.625 9.20581C2.625 8.92104 2.83662 8.68569 3.11117 8.64845L3.1875 8.64331L14.4375 8.64331C14.7482 8.64331 15 8.89515 15 9.20581Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1215 13.3254C8.34164 13.5446 8.34241 13.9008 8.12321 14.1209C7.92394 14.321 7.61149 14.3399 7.39093 14.1769L7.32772 14.1226L2.79022 9.60461C2.58949 9.40474 2.57123 9.09116 2.73545 8.8706L2.79019 8.80744L7.32769 4.28869C7.54781 4.06947 7.90396 4.07021 8.12318 4.29033C8.32247 4.49045 8.33997 4.80298 8.17613 5.02285L8.12153 5.08583L3.98451 9.20623L8.1215 13.3254Z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-back.73aa1d15.svg";
export { ForwardRef as ReactComponent };